import { logged } from 'apollo/cache';
import axios, { AxiosResponse } from 'axios';
import config from 'config';

const { apiRestUrl, apiOperationCostUrl } = config;

const axiosInstance = axios.create({
  baseURL: apiRestUrl || '',
});

const ssoAxiosInstance = axios.create({
  baseURL:
    'https://lite-api.auth.us-east-1.amazoncognito.com/login?client_id=5aanjvqc5hge0o9jel01qk8q65&redirect_uri=https://lite-cloudcar-api.cloudcar.dev/dev/idp-fallback&response_type=code',
});

const operationCostAxiosInstance = axios.create({
  baseURL: apiOperationCostUrl || '',
});

const analyticAxiosInstance = axios.create({
  baseURL: 'https://apimazqa.grupokaufmann.com/qas',
});


const refreshTokensRequest = async (): Promise<AxiosResponse> =>
  new Promise((resolve, reject) => {
    try {
      const data = {
        refreshToken: localStorage.getItem('RefreshToken'),
      };
      const result = axios.post(
        `${apiRestUrl as string}/lite/refreshToken`,
        data,
      );
      resolve(result);
    } catch (err) {
      reject(err);
    }
  });

const headerWithAuthorization = (): { [key: string]: string } => {
  return {
    authorization: `Bearer ${localStorage.getItem('IdToken') as string}`,
  };
};

export const logout = (): void => {
  logged(false);
  localStorage.clear();
  window.location.replace('/login');
};

const utils = {
  axiosInstance,
  operationCostAxiosInstance,
  analyticAxiosInstance,
  logout,
  headerWithAuthorization,
  ssoAxiosInstance,
  refreshTokensRequest,
};

export default utils;
